import React, { useState } from 'react';

const VideoTestimonials = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  // Fake Video Reviews Data (Aap yahan real youtube/vimeo embed links ya local mp4 links daal sakte hain)
  const videoReviews = [
    {
      id: 1,
      clientName: "Shazib Sheikh",
      role: "Founder",
      company: "Orchard Publishing",
      thumbnail: "/thumbnail.png",
      videoUrl: "/shariqshareef.mp4",
    },
    {
      id: 2,
      clientName: "Sophia Lopez",
      role: "E-commerce Head",
      company: "Glitz & Glam",
      thumbnail: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=600&h=400&q=80",
      videoUrl: "https://www.w3schools.com/html/movie.mp4",
    },
    {
      id: 3,
      clientName: "Ethan Hunt",
      role: "Tech Director",
      company: "Core Cyber Sec",
      thumbnail: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=600&h=400&q=80",
      videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4",
    },
  ];

  const nextSlide = () => {
    setActiveSlide((prev) => (prev === videoReviews.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setActiveSlide((prev) => (prev === 0 ? videoReviews.length - 1 : prev - 1));
  };

  return (
    <section className="w-full py-8 md:py-24 bg-transparent relative z-10 overflow-hidden border-none select-none">

      {/* 🪄 Custom CSS for the Crawling Dashed Border Animation */}
      <style>{`
        @keyframes dash-crawl {
          to {
            stroke-dashoffset: -20;
          }
        }
        .animate-dashed-border {
          animation: dash-crawl 1.2s linear infinite;
        }
      `}</style>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">

          {/* ======================================================= */}
          {/* ✍️ LEFT SIDE: HEADINGS & CONTENT (Takes 5 columns)       */}
          {/* ======================================================= */}
          <div className="lg:col-span-5 text-center lg:text-left space-y-6">
            <div className="inline-flex items-center gap-2 bg-[#F3CA52]/10 border border-[#F3CA52]/20 px-4 py-1.5 rounded-full mb-4">
              <span className="w-2 h-2 rounded-full bg-[#F3CA52] animate-pulse" />
              <span className="text-xs font-black text-[#F3CA52] uppercase tracking-[0.2em]">
                Real Feedback
              </span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-black text-white tracking-tight leading-none">
              Hear Our Clients <br className="hidden sm:inline" />
              <span className="text-[#F3CA52]">In Action!</span>
            </h2>
            <div className="w-16 h-1 bg-[#F3CA52] mx-auto lg:mx-0 rounded-full" />
            <p className="text-sm sm:text-base text-zinc-400 leading-relaxed max-w-xl mx-auto lg:mx-0 font-medium">
              We don't just make claims; our clients speak for our work on video. Discover how we helped founders scale their technical ecosystems, build highly stable infrastructures, and dominate their digital spaces.
            </p>

            {/* Custom Navigation Buttons for Desktop */}
            <div className="hidden lg:flex items-center gap-4 pt-4">
              <button
                onClick={prevSlide}
                className="w-12 h-12 rounded-full border border-zinc-800 bg-zinc-950/40 hover:border-[#F3CA52] text-white hover:text-[#F3CA52] flex items-center justify-center transition-all duration-300 backdrop-blur-md shadow-lg"
              >
                ←
              </button>
              <button
                onClick={nextSlide}
                className="w-12 h-12 rounded-full border border-zinc-800 bg-zinc-950/40 hover:border-[#F3CA52] text-white hover:text-[#F3CA52] flex items-center justify-center transition-all duration-300 backdrop-blur-md shadow-lg"
              >
                →
              </button>
            </div>
          </div>

          {/* ======================================================= */}
          {/* 📹 RIGHT SIDE: ANIMATED VIDEO CAROUSEL (Takes 7 columns) */}
          {/* ======================================================= */}
          <div className="lg:col-span-7 relative w-full flex flex-col items-center">

            {/* Video Frame Card */}
            <div className="relative w-full aspect-video sm:aspect-[16/10] rounded-[2rem] p-3 flex items-center justify-center overflow-hidden">

              {/* ⚡ THE MOVING DASHED SVG OVERLAY */}
              <svg className="absolute inset-0 w-full h-full p-1" xmlns="http://www.w3.org/2000/svg">
                <rect
                  x="4"
                  y="4"
                  width="calc(100% - 8px)"
                  height="calc(100% - 8px)"
                  rx="24"
                  fill="none"
                  stroke="#F3CA52"
                  strokeWidth="2.5"
                  strokeDasharray="8, 6"
                  className="animate-dashed-border"
                />
              </svg>

              {/* Inner Video Container */}
              <div className="w-full h-full rounded-[1.6rem] overflow-hidden bg-zinc-950 relative group/video border border-zinc-900 shadow-2xl">

                {/* HTML5 Video Player */}
                <video
                  key={videoReviews[activeSlide].id}
                  controls
                  poster={videoReviews[activeSlide].thumbnail}
                  className="w-full h-full object-cover"
                >
                  <source src={videoReviews[activeSlide].videoUrl} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>

                {/* Subtle client tag at bottom of video overlay */}
                <div className="absolute bottom-4 left-4 bg-black/70 backdrop-blur-md border border-zinc-800/80 px-4 py-2 rounded-xl pointer-events-none">
                  <h4 className="text-xs sm:text-sm font-black text-white">
                    {videoReviews[activeSlide].clientName}
                  </h4>
                  <p className="text-[10px] sm:text-xs text-zinc-400 font-medium">
                    {videoReviews[activeSlide].role} @ <span className="text-[#F3CA52]">{videoReviews[activeSlide].company}</span>
                  </p>
                </div>

              </div>
            </div>

            {/* Mobile Controls & Pagination Indicators */}
            <div className="flex lg:hidden items-center gap-6 mt-6">
              <button
                onClick={prevSlide}
                className="w-10 h-10 rounded-full border border-zinc-800 bg-zinc-950/20 text-white flex items-center justify-center active:scale-95"
              >
                ←
              </button>

              {/* Pagination Dots */}
              <div className="flex items-center gap-2">
                {videoReviews.map((_, idx) => (
                  <div
                    key={idx}
                    className={`h-1.5 rounded-full transition-all duration-300 ${idx === activeSlide ? 'w-6 bg-[#F3CA52]' : 'w-1.5 bg-zinc-700'}`}
                  />
                ))}
              </div>

              <button
                onClick={nextSlide}
                className="w-10 h-10 rounded-full border border-zinc-800 bg-zinc-950/20 text-white flex items-center justify-center active:scale-95"
              >
                →
              </button>
            </div>

          </div>

        </div>
      </div>
    </section>
  );
};

export default VideoTestimonials;